import { render, staticRenderFns } from "./pregnancy-add.vue?vue&type=template&id=10abd094&"
import script from "./pregnancy-add.vue?vue&type=script&lang=js&"
export * from "./pregnancy-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports